import { useQuery } from '@tanstack/react-query';
import getFilesService from '../../service/getFiles/getFiles.service';
import { pageState$ } from '../../state';

export const IUseGetFilesKey = 'IUseGetFilesKey';
export interface IGetFilesPayload {
  path: string;
  search: string;
}

export function useQueryGetFiles(isEnabled: boolean, payload: IGetFilesPayload) {
  return useQuery({
    queryKey: [IUseGetFilesKey, payload],
    enabled: isEnabled,
    queryFn: ({ signal }) => getFilesService({ signal, payload }),
    select: (data) => {
      pageState$.activeItem.data.set(data.data.blobs);
      pageState$.activeItem.title.set(decodeURIComponent(payload.path.split('/').pop() || ''));
      return data.data.blobs;
    },
  });
}
